/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default () => {
  return new Promise(async (resolve) => {
    const SinglePageCheckoutSaga = await import(
      /* webpackChunkName: "checkout-store" */ './SinglePageCheckout.saga'
    ).then((mod) => mod.default);
    resolve(
      useInjectReducerAndSaga(null, { key: 'SinglePageCheckoutSaga', saga: SinglePageCheckoutSaga })
    );
  });
};
